
const _fs_part_keys = ['(E)FU', '(E)F0', '(E)F1', '(E)F2', '(E)F3', '(E)F4', '(E)F5']
const PARTITIONS = {    
    'f_scale': {
        'label_str': "Rating",
        'colors':  ['#333333', '#00ccaa', '#0768df', '#dbb40c', '#f97306', '#e50000', '#960056'],
        'partition_func': tor => {
            let fs = tor['geojson']['properties']['f-scale'];
            return '(E)F' + (fs == -9 ? 'U' : fs);
        },
        'part_keys': _fs_part_keys,
        'to_header_string_func': toggled => {
            if (toggled.length == _fs_part_keys.length) {
                return '';
            }

            toggled = [...toggled];
            let strs = [];

            if (toggled.includes('(E)FU')) {
                strs.push('(E)FU');
                toggled = toggled.filter(t => t != '(E)FU');
            }
            toggled.sort();

            while (toggled.length > 0) {
                let cat_range = toggled.shift();
                const cat_range_start = parseInt(cat_range.charAt(4));
                let looking_for = cat_range_start + 1;

                while(toggled.length > 0 && toggled[0].charAt(4) == looking_for) {
                    toggled.shift();
                    looking_for++;
                }

                if (looking_for > cat_range_start + 1) {
                    cat_range += '\u2013(E)F' + (looking_for - 1);
                }
                strs.push(cat_range);
            }

            return strs.join(', ');
        }
    }
};

class Partitioner {
    constructor(name, label_str, colors, partition_func, part_keys, to_string) {
        this.name = name;
        this.label_str = label_str;
        this.colors = colors;
        this.partition_func = partition_func;
        this.part_keys = part_keys;
        this.to_header_string = to_string;
    }

    partition(tor_list) {
        let tor_f_scale = {};
        this.part_keys.forEach(pk => {tor_f_scale[pk] = []});
    
        tor_list.forEach(tor => {
            tor_f_scale[this.partition_func(tor)].push(tor);
        });
    
        return tor_f_scale;
    }

    static fromRepr(str) {
        const part = PARTITIONS[str];
        return new Partitioner(str, part['label_str'], part['colors'], part['partition_func'], part['part_keys'], 
            part['to_header_string_func']);
    }

    toRepr() {
        return this.name;
    }
}

var f_scale_partitioner = Partitioner.fromRepr('f_scale');

export {Partitioner, f_scale_partitioner};